export type PackDropdownOption = {
  value: string;
  label: string;
  units: number;
};

export const quantityOptionsByPack: Record<string, PackDropdownOption[]> = {
  "4,8,12 Units Titration Packs": [
    { value: "180", label: "1 Box = 180 Cartridges (Up to 48 units/day)", units: 48 },
    { value: "360", label: "2 Boxes = 360 Cartridges (Up to 96 units/day)", units: 96 },
    { value: "540", label: "3 Boxes = 540 Cartridges (Up to 144 units/day)", units: 144 },
  ],

  "4,8 Units Titration Packs": [
    { value: "180", label: "1 Box = 180 Cartridges (Up to 36 units/day)", units: 36 },
    { value: "360", label: "2 Boxes = 360 Cartridges (Up to 72 units/day)", units: 72 },
    { value: "540", label: "3 Boxes = 540 Cartridges (Up to 108 units/day)", units: 108 },
  ],

  "8,12 Units Combo Packs": [
    { value: "180", label: "1 Box = 180 Cartridges (Up to 60 units/day)", units: 60 },
    { value: "360", label: "2 Boxes = 360 Cartridges (Up to 120 units/day)", units: 120 },
    { value: "540", label: "3 Boxes = 540 Cartridges (Up to 180 units/day)", units: 180 },
  ],

  "4 Units Cartridges": [
    { value: "90", label: "1 Box = 90 Cartridges (Up to 12 units/day)", units: 12 },
    { value: "180", label: "2 Boxes = 180 Cartridges (Up to 24 units/day)", units: 24 },
    { value: "270", label: "3 Boxes = 270 Cartridges (Up to 36 units/day)", units: 36 },
  ],

  "8 Units Cartridges": [
    { value: "90", label: "1 Box = 90 Cartridges (Up to 24 units/day)", units: 24 },
    { value: "180", label: "2 Boxes = 180 Cartridges (Up to 48 units/day)", units: 48 },
    { value: "270", label: "3 Boxes = 270 Cartridges (Up to 72 units/day)", units: 72 },
  ],

  "12 Units Cartridges": [
    { value: "90", label: "1 Box = 90 Cartridges (Up to 36 units/day)", units: 36 },
    { value: "180", label: "2 Boxes = 180 Cartridges (Up to 72 units/day)", units: 72 },
    { value: "270", label: "3 Boxes = 270 Cartridges (Up to 108 units/day)", units: 108 },
  ],
};

export const getQtyLabel = (packagingSize: string | undefined, qty: string | number | undefined): string => {
  if (!qty) return "N/A";
  const qtyStr = String(qty);
  if (packagingSize && quantityOptionsByPack[packagingSize]) {
    const match = quantityOptionsByPack[packagingSize].find((opt) => opt.value === qtyStr);
    if (match) return match.label;
  }
  return qtyStr;
};
